import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ClientPluginBuilder3nx9qxmpfnzts as ClientPluginBuilder } from './ClientPluginBuilder.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ClientPluginInstance$onClose$lambda() {
  return Unit_instance;
}
var ClientPluginInstanceClass;
function ClientPluginInstance() {
  if (ClientPluginInstanceClass === VOID) {
    class $ {
      constructor(key, config, body) {
        this.f60_1 = key;
        this.g60_1 = config;
        this.h60_1 = body;
        var tmp = this;
        tmp.i60_1 = ClientPluginInstance$onClose$lambda;
      }
      h5m(scope) {
        var tmp0 = new (ClientPluginBuilder())(this.f60_1, scope, this.g60_1);
        // Inline function 'kotlin.apply' call
        this.h60_1(tmp0);
        var pluginBuilder = tmp0;
        this.i60_1 = pluginBuilder.p5s_1;
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = pluginBuilder.o5s_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.h5m(scope);
        }
      }
      l6() {
        this.i60_1();
      }
    }
    initMetadataForClass($, 'ClientPluginInstance', VOID, VOID, [AutoCloseable()]);
    ClientPluginInstanceClass = $;
  }
  return ClientPluginInstanceClass;
}
//region block: exports
export {
  ClientPluginInstance as ClientPluginInstance3k1rpw72h98wh,
};
//endregion

//# sourceMappingURL=ClientPluginInstance.mjs.map
